import { render, staticRenderFns } from "./event-banner.vue?vue&type=template&id=63ca1db0&scoped=true&"
import script from "./event-banner.vue?vue&type=script&lang=js&"
export * from "./event-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca1db0",
  null
  
)

export default component.exports